// src/layout/Topbar.jsx
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/auth.store";
import { useEffect } from "react";

export default function Topbar() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);

  // Inicializar desde sessionStorage si se refresca la página
  const init = useAuthStore((s) => s.init);
  useEffect(() => {
    if (!token) init();
  }, []);

  const handleLogout = () => {
    logout(); // limpia token y user
    navigate("/login", { replace: true });
  };

  return (
    <header style={styles.header}>
      <div style={styles.left}>
        <strong>ISP ERP {user?.username ? `- ${user.username}` : ""}</strong>
      </div>
      <div style={styles.right}>
        {token && (
          <button onClick={handleLogout} style={styles.button}>
            Salir
          </button>
        )}
      </div>
    </header>
  );
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#0f172a",
    color: "#fff",
    padding: "12px 24px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  left: {
    fontSize: 18,
  },
  right: {},
  button: {
    padding: "6px 12px",
    borderRadius: 6,
    border: "none",
    backgroundColor: "#ef4444",
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    transition: "background-color 0.2s",
  },
};
